import HomeIcon from '@mui/icons-material/Home'
import InfoIcon from '@mui/icons-material/Info'
import ListOutlinedIcon from '@mui/icons-material/ListOutlined'
import SendIcon from '@mui/icons-material/Send'
import DescriptionIcon from '@mui/icons-material/Description'
import SettingsIcon from '@mui/icons-material/Settings'
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import { i18n } from '~/src/libs/i18next/config'

import { TNestedSidebarItemProps } from '~/src/types/sidebar'

export const SIDEBAR_LIST: TNestedSidebarItemProps[] = [
  { icon: <HomeIcon color="action" />, text: i18n.t('sidebar.home'), link: '/admin', list: [] },
  {
    icon: <SendIcon color="action" />,
    text: i18n.t('sidebar.container'),
    link: '',
    list: [
      {
        icon: null,
        text: i18n.t('sidebar.container_order'),
        link: '/admin/order/container-order/list',
      },
      {
        icon: null,
        text: i18n.t('sidebar.contact_order'),
        link: '/admin/order/contact-order/list',
      },
      {
        icon: null,
        text: i18n.t('sidebar.wish_list'),
        link: '/admin/wish-list/list',
      },
      {
        icon: null,
        text: i18n.t('sidebar.proforma_invoice'),
        link: '/admin/order/proforma-invoice/list',
      },
      {
        icon: null,
        text: i18n.t('sidebar.s_of_a'),
        link: '/admin/order/statement-of-account/list',
      },
      {
        icon: null,
        text: i18n.t('sidebar.favorites'),
        link: '/admin/order/favorites/list',
      },
    ],
  },
  {
    icon: <SupervisorAccountIcon color="action" />,
    text: i18n.t('sidebar.member_manage'),
    link: '',
    list: [
      {
        icon: null,
        text: i18n.t('sidebar.member'),
        link: '/admin/member/list',
      },
      // {
      //   icon: null,
      //   text: i18n.t('sidebar.customer'),
      //   link: '#',
      // },
    ],
  },
  {
    icon: <DescriptionIcon color="action" />,
    text: i18n.t('new_stock_list.new_stock_list'),
    link: '/admin/special-offer',
    list: [],
  },
  {
    icon: <ListOutlinedIcon color="action" />,
    text: i18n.t('sidebar.item'),
    link: '/admin/items/list',
    list: [],
  },
  {
    icon: <SupervisedUserCircleIcon color="action" />,
    text: i18n.t('sidebar.user'),
    link: '/admin/user/list',
    list: [],
  },
  {
    icon: <InfoIcon color="action" />,
    text: i18n.t('sidebar.news'),
    link: '/admin/news/list',
    list: [],
  },
  {
    icon: <SettingsIcon color="action" />,
    text: i18n.t('sidebar.setting'),
    link: '',
    list: [
      {
        icon: null,
        text: i18n.t('sidebar.general'),
        link: '/admin/settings/general',
      },
      {
        icon: null,
        text: i18n.t('sidebar.currency'),
        link: '/admin/settings/currency',
      },
      // {
      //   icon: null,
      //   text: i18n.t('sidebar.freight'),
      //   link: '/admin/settings/freight/list',
      // },
    ],
  },
]
